export enum ChartVariants {
    Labels,
    Packs,
    LandrTopPacks,
}

export type ChartEntry = {
    guid: string;
    slug: string;
    name?: string;
    artworkUrl?: string;
    lastRank: number | null;
    currentRank: number;
    isNew: boolean;
    subItemsCount?: number;
    artistName?: string;
};

export enum ChartRankChange {
    Up,
    Down,
    None,
}
